// eslint-disable-next-line @typescript-eslint/no-var-requires, no-undef
const CryptoJS = require('crypto-js');

export function generateRandomHash(number = 20) {
    const randomHex = Array.from({ number }, () => {
        const randomByte = Math.floor(Math.random() * 256).toString(16);
        return randomByte.length === 1 ? '0' + randomByte : randomByte;
    }).join('');

    // Use CryptoJS to create a hash from the hexadecimal string
    const hash = CryptoJS.SHA256(randomHex);

    // Convert the hash to a hexadecimal representation
    const hashHex = hash.toString(CryptoJS.enc.Hex);

    return hashHex;
}
